// state
export const state = {
  markets: []
}

// getters
export const getters = {
  markets: state => {
    return state.markets
  }
}

// mutations
export const mutations = {
  SET_MARKETS(state, markets) {
    state.markets = markets
  },
}

// actions
export const actions = {
  async setMarkets({ commit }, markets) {
    commit('SET_MARKETS', markets);
  }
}
